import React, { useContext, useEffect, useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { AuthContext } from '../AuthContext';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import instance from '../helpers';
import ProfileSlideshow from './components/ProfileSlideshow';
import ProfileVideoList from './components/ProfileVideoList';
import ProfileHero from './components/ProfileHero';
import ProfileSectionCard from './components/ProfileSectionCard';

import LoadingIndicator from '../components/LoadingIndicator';
import { useTranslation } from 'react-i18next';

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}. ${month}. ${year}`;
}

const fetchDataCategories = async (id)=>{
  const response = await instance().get(`/profile/${id}`);
  return response.data;
}

const fetchDataStatus = async ()=>{
  const response = await instance().get(`/status-profile`);
  return response;
}
function Profiles() {
  const { t } = useTranslation();

  const { id } = useParams();
  const [statusIsOK, setStatusIsOK] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { data, status } = useQuery([], () => fetchDataCategories(id),{cacheTime:0});
  const statusArr = useQuery('statusData', fetchDataStatus,{cacheTime:0});

  if (status === 'error') {
    enqueueSnackbar(`Error fetching data /profile`, { variant: 'error', autoHideDuration: 1000 });
  };
  const { verifyToken } = useContext(AuthContext);

  useEffect(() =>{ verifyToken()},[]);

  useEffect(() =>{ 
    if(statusArr?.data?.data?.data && data?.status?._id){
      const index = statusArr?.data?.data?.data.findIndex(e=>e._id === data?.status?._id)
      if(index === 1 && statusIsOK === false){
        setStatusIsOK(true);
      }    
    }
  },[statusArr]);

  if (status === 'loading') return <LoadingIndicator/>;

  if (statusArr?.status === 'loading') return <LoadingIndicator/>;

  const dateRange = data && data.birthDate && data.deathDate
    ? `${formatDate(data.birthDate)} – ${formatDate(data.deathDate)}`
    : '';

  return (statusIsOK === false) ? <Container component="main" maxWidth="sm" sx={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
  <Box sx={{ my: 4, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h2" component="h1" gutterBottom>
      {t('profileApproved1')}
      </Typography>
      <Typography variant="body1">
      {t('profileApproved2')}
      </Typography>
    </Box>
  </Container> : (
    <Container component="main" maxWidth="xl" sx={{ marginTop: { xs: '82px', md: '96px' }, pb: 8 }}>
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: { xs: 3, md: 4 } }}>
        <ProfileHero name={data?.name || ''} dateRange={dateRange} biography={data?.biography || ''} />

        <ProfileSectionCard
          title="Fotografie"
          subtitle="Spomienkové fotografie sú zobrazené ako pokojná prezentácia. Kliknutím na fotografiu ju môžete zväčšiť."
          sx={{ maxWidth: 1240 }}
        >
          <ProfileSlideshow itemData={data?.gallery || []} />
        </ProfileSectionCard>

        {(data?.videos || []).length > 0 && (
          <ProfileSectionCard
            title="Videá"
            subtitle="Krátke videá zachytávajú dôležité spomienky. Pre prehratie stlačte tlačidlo play priamo vo videu."
            sx={{ maxWidth: 1240 }}
          >
            <ProfileVideoList itemData={data?.videos || []} showTitle={false} />
          </ProfileSectionCard>
        )}
      </Box>
    </Container>
  );
}

export default Profiles;
